<div class="container" [formGroup]="addForm">
    <div class="row wrapperRow">
        <div class="offset-lg-2 col-lg-8 offset-lg-2" >
            <mat-card appearance="outlined">
                <mat-card-header>
                    <mat-card-title>
                        Partner anlegen
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="row marginBottom2Rem" *ngIf="!this.addForm.value?.image.url">
                        <div class="col-sm-12">
                            <div ngx-dropzone [accept]="'image/jpeg,image/jpg,image/png'" (change)="onSelect($event)">
                                <ngx-dropzone-label>
                                    <div>
                                        <h3>Bild hierher ziehen</h3>
                                        <h5>ODER</h5>
                                        <button mat-button color="accent">Durchsuchen</button>
                                    </div>
                                </ngx-dropzone-label>
                                <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of files"
                                    [file]="f" [removable]="true" (removed)="onRemove(f)">
                                    <!-- <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label> -->
                                </ngx-dropzone-image-preview>

                            </div>
                            <mat-error *ngIf="addForm.get('image').hasError('required')">
                                Logo <strong>muss</strong> hochgeladen werden
                            </mat-error>
                        </div>
                    </div>
                    <div class="row ">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Rolle:</mat-label>
                                <mat-select formControlName="businessRole">
                                    <mat-option *ngFor="let sortOption of sortOptions" [value]="sortOption.value">
                                        {{sortOption.viewValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error>
                                    Rolle <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Firmenname:</mat-label>
                                <input matInput formControlName="name">
                                <mat-error *ngIf="addForm.get('name').hasError('required')">
                                    Firmenname <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div formGroupName="address">
                        <div class="row">
                            <div class="col-sm-12">
                                <mat-form-field class="full-width">
                                    <mat-label>Straße und Hausnummer:</mat-label>
                                    <input matInput formControlName="street">
                                    <mat-error *ngIf="addForm.get('address').get('street').hasError('required')">
                                        Hausnummer <strong>muss</strong> angegeben werden
                                    </mat-error>
                                    <mat-error *ngIf="addForm.get('address').get('street').hasError('pattern')">
                                        Straße und Hausnummer <strong>muss</strong> im Format Straße Hausnummer
                                        angegeben
                                        werden
                                    </mat-error>
                                </mat-form-field>
                            </div>

                        </div>
                        <div class="row marginBottom2Rem">
                            <div class="col-sm-4">
                                <mat-form-field class="full-width">
                                    <mat-label>PLZ:</mat-label>
                                    <input matInput formControlName="postcode">
                                    <mat-error *ngIf="addForm.get('address').get('postcode').hasError('required')">
                                        PLZ <strong>muss</strong> angegeben werden
                                    </mat-error>
                                    <mat-error *ngIf="addForm.get('address').get('postcode').hasError('required')">
                                        PLZ <strong>muss</strong> aus 5 Zahlen bestehen
                                    </mat-error>
                                    <mat-error *ngIf="addForm.get('address').get('postcode').hasError('minlength')">
                                        PLZ <strong>muss</strong> aus 5 Zahlen bestehen
                                    </mat-error>
                                    <mat-error *ngIf="addForm.get('address').get('postcode').hasError('maxlength')">
                                        PLZ <strong>muss</strong> aus 5 Zahlen bestehen
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-sm-8">
                                <mat-form-field class="full-width">
                                    <mat-label>Ort:</mat-label>
                                    <input matInput formControlName="city">
                                    <mat-error *ngIf="addForm.get('address').get('postcode').hasError('required')">
                                        Hausnummer <strong>muss</strong> angegeben werden
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <!-- <div class="row marginBottom2Rem">
                            <div class="col-sm-4">
                                <button mat-button class="full-width" color="accent" (click)="getPositions()">
                                    Koordinaten ermitteln
                                    <mat-icon *ngIf="loadingLocation">
                                        <mat-spinner color="primary" diameter="2i">
                                        </mat-spinner>
                                    </mat-icon>
                                </button>
                            </div>
                            <div class="col-sm-8" *ngIf="loadedLocation">
                                <h5>Koordinaten erfolgreich ermittelt!</h5>
                            </div>
                        </div> -->
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>

    <div class="row wrapperRow">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined">
                <mat-card-header>
                    <mat-card-title>
                        Öffnungszeiten anlegen
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="add-lessons-form">
                        <button mat-button color="accent" (click)="addOpeningHours()">
                            Hinzufügen <mat-icon class="add-course-btn">add</mat-icon>
                        </button>
                        <ng-container class="full-width" formArrayName="openingHours">
                            <ng-container *ngFor="let lessonForm of openingHours.controls; let i = index">
                                <div class="row flex" [formGroup]="lessonForm">
                                    <div class="col-sm-9">
                                        <mat-form-field class="full-width">
                                            <mat-label>Öffnungszeit:</mat-label>
                                            <input matInput formControlName="name">
                                            <mat-error *ngIf="addForm.get('name').hasError('required')">
                                                Öffnungszeit <strong>muss</strong> angegeben werden
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-1">
                                    </div>
                                    <div class="col-sm-2">

                                        <button style="margin-top: 0.5rem;" mat-button color="error"
                                            (click)="deleteOpeningHours(i)">
                                            Löschen <mat-icon class="add-course-btn">delete_forever
                                            </mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>

    <div class="row wrapperRow">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined">
                <mat-card-header>
                    <mat-card-title>
                        Kontaktdaten anlegen
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="add-lessons-form">
                        <button mat-button color="accent" (click)="addContactChannels()">
                            Hinzufügen <mat-icon class="add-course-btn">add</mat-icon>
                        </button>
                        <ng-container class="full-width" formArrayName="contactChannels">
                            <ng-container *ngFor="let lessonForm of contactChannels.controls; let i = index">
                                <div class="row flex" [formGroup]="lessonForm">
                                    <div class="col-sm-3">
                                        <mat-form-field class="full-width">
                                            <mat-label>Typ:</mat-label>
                                            <mat-select formControlName="channelType"
                                                (selectionChange)="changeAvalibleContactChannels($event)">
                                                <mat-option *ngFor="let sortOption of contactChannelOptions"
                                                    [value]="sortOption.value" [disabled]="sortOption.state">
                                                    {{sortOption.viewValue}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error>
                                                Rolle <strong>muss</strong> angegeben werden
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-6">
                                        <mat-form-field class="full-width">
                                            <mat-label>Adresse:</mat-label>
                                            <input matInput formControlName="channelData">
                                        </mat-form-field>

                                    </div>
                                    <div class="col-sm-1"></div>
                                    <div class="col-sm-2">
                                        <button style="margin-top: 0.5rem;" mat-button color="error"
                                            (click)="deletContactChannels(i)">
                                            Löschen <mat-icon class="add-course-btn">delete_forever
                                            </mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>

    <div class="row wrapperRow">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined">
                <mat-card-header>
                    <mat-card-title>
                        Benutzerkonten anlegen
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="add-lessons-form">
                        <button mat-button color="accent" (click)="addMember()">
                            Hinzufügen <mat-icon class="add-course-btn">add</mat-icon>
                        </button>
                        <ng-container class="full-width" formArrayName="members">
                            <ng-container [formGroup]="lessonForm"
                                *ngFor="let lessonForm of members.controls; let i = index">
                                <div formGroupName="person">
                                    <div class="row flex">
                                        <div class="col-sm-4">
                                            <mat-form-field class="full-width">
                                                <mat-label>Anrede:</mat-label>
                                                <mat-select formControlName="gender">
                                                    <mat-option *ngFor="let sortOption of genderOptions"
                                                        [value]="sortOption.value">
                                                        {{sortOption.viewValue}}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-error
                                                    *ngIf="addForm.get('members')['controls'][i]['controls']['person']['controls']['gender'].hasError('required')">
                                                    Anrede <strong>muss</strong> angegeben werden
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-sm-4">
                                            <mat-form-field class="full-width">
                                                <mat-label>Titel:</mat-label>
                                                <input matInput formControlName="title">


                                            </mat-form-field>
                                        </div>
                                        <div class="col-sm-4">
                                            <mat-form-field class="full-width">
                                                <mat-label>Geburtstag:</mat-label>
                                                <input matInput formControlName="birthday" type="date">
                                                <mat-error
                                                    *ngIf="addForm.get('members')['controls'][i]['controls']['person']['controls']['birthday'].hasError('required')">
                                                    Geburtstag <strong>muss</strong> angegeben werden
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row flex">
                                        <div class="col-sm-6">
                                            <mat-form-field class="full-width">
                                                <mat-label>Vorname:</mat-label>
                                                <input matInput formControlName="firstName">
                                                <mat-error
                                                    *ngIf="addForm.get('members')['controls'][i]['controls']['person']['controls']['firstName'].hasError('required')">
                                                    Vorname <strong>muss</strong> angegeben werden
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-sm-6">
                                            <mat-form-field class="full-width">
                                                <mat-label>Nachname:</mat-label>
                                                <input matInput formControlName="lastName">
                                                <mat-error
                                                    *ngIf="addForm.get('members')['controls'][i]['controls']['person']['controls']['lastName'].hasError('required')">
                                                    Nachname <strong>muss</strong> angegeben werden
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>

                                <div formGroupName="address">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <mat-form-field class="full-width">
                                                <mat-label>Straße und Hausnummer:</mat-label>
                                                <input matInput formControlName="street">
                                                <mat-error
                                                    *ngIf="addForm.get('members')['controls'][i]['controls']['address']['controls']['street'].hasError('required')">
                                                    Straße und Hausnummer <strong>muss</strong> angegeben
                                                    werden
                                                </mat-error>
                                                <mat-error
                                                    *ngIf="addForm.get('members')['controls'][i]['controls']['address']['controls']['street'].hasError('pattern')">
                                                    Straße und Hausnummer <strong>muss</strong> im Format
                                                    Straße
                                                    Hausnummer angegeben
                                                    werden
                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                    </div>
                                    <div class="row marginBottom2Rem">
                                        <div class="col-sm-4">
                                            <mat-form-field class="full-width">
                                                <mat-label>PLZ:</mat-label>
                                                <input matInput formControlName="postcode" type="number">
                                                <mat-error
                                                    *ngIf="addForm.get('members')['controls'][i]['controls']['address']['controls']['postcode'].hasError('required')">
                                                    PLZ <strong>muss</strong> angegeben werden
                                                </mat-error>

                                                <mat-error
                                                    *ngIf="addForm.get('members')['controls'][i]['controls']['address']['controls']['postcode'].hasError('minlength')">
                                                    PLZ <strong>muss</strong> aus 5 Zahlen bestehen
                                                </mat-error>

                                                <mat-error
                                                    *ngIf="addForm.get('members')['controls'][i]['controls']['address']['controls']['postcode'].hasError('maxlength')">
                                                    PLZ <strong>muss</strong> aus 5 Zahlen bestehen
                                                </mat-error>

                                            </mat-form-field>
                                        </div>
                                        <div class="col-sm-8">
                                            <mat-form-field class="full-width">
                                                <mat-label>Ort:</mat-label>
                                                <input matInput formControlName="city">
                                                <mat-error
                                                    *ngIf="addForm.get('members')['controls'][i]['controls']['address']['controls']['city'].hasError('required')">
                                                    Ort <strong>muss</strong> angegeben werden
                                                </mat-error>

                                                <mat-error
                                                    *ngIf="addForm.get('members')['controls'][i]['controls']['address']['controls']['city'].hasError('pattern')">
                                                    Ort <strong>muss</strong> angegeben werden
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <h6>Kontaktdaten</h6>
                                <div class="row flex">
                                    <div class="col-sm-6">
                                        <mat-form-field class="full-width">
                                            <mat-label>Mobil:</mat-label>
                                            <input matInput formControlName="mobile" type="number">

                                            <mat-error
                                                *ngIf="addForm.get('members')['controls'][i]['controls']['mobile'].hasError('required')">
                                                Mobilnummer <strong>muss</strong> angegeben werden
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-6">
                                        <mat-form-field class="full-width">
                                            <mat-label>Mail-Adresse:</mat-label>
                                            <input matInput formControlName="email" type="email">

                                            <mat-error
                                                *ngIf="addForm.get('members')['controls'][i]['controls']['email'].hasError('required')">
                                                E-mail <strong>muss</strong> angegeben werden
                                            </mat-error>

                                            <mat-error
                                                *ngIf="addForm.get('members')['controls'][i]['controls']['email'].hasError('email')">
                                                E-mail <strong>muss</strong> gültiges Format haben
                                            </mat-error>

                                        </mat-form-field>
                                    </div>
                                </div>
                                <button style="margin-top: 0.5rem;" mat-button color="error"
                                    (click)="deletMembers(i)">
                                    Löschen <mat-icon class="add-course-btn">delete_forever</mat-icon>
                                </button>


                            </ng-container>
                        </ng-container>
                    </div>
                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="primary" (click)="createPartner()">Anlegen</button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>
</div>